import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NavController, NavParams } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Member } from "../../models/interfaces/member.model";
import { Role } from "../../models/interfaces/role.model";
import { CommitteePage } from "../../pages/committee/committee";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-committeemember_update",
  templateUrl: "committeemember_update.html",
})
export class CommitteeMemberUpdatePage {
  public static readonly CMBR_DEL_ACCESS = "deleteCommitteemember";
  private currentUser: Member;
  private hasDelCMbrAccess: boolean = false;
  private id: string;
  private cm_id: string;
  private ro_id: string;
  private mb_id: string;
  private mb_email_id: string;
  private mb_hashname: string;
  private mb_firstname: string;
  private mb_lastname: string;
  private mb_photo: string;
  private ref_mb: string;
  private ro_name: string;
  private cm_sort: string;
  private committeememberForm: FormGroup;
  private role$: Observable<Role[]>;
  private styleName: string ="";

  constructor(private configService: ConfigService,public alertCtrl: AlertController, public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private db: DbserviceProvider,
  ) {
    console.log("CommitteeMemberUpdatePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    if (this.authService.currentUser) {
      this.authService.currentUser.subscribe(
        (user) => {
          this.currentUser = user;
          this.hasDelCMbrAccess = this.db.hasAccess(CommitteeMemberUpdatePage.CMBR_DEL_ACCESS);
        },
      );
    }
    this.committeememberForm = this.formBuilder.group({
      "cm_sort": "",
      "ref_mb": "",
      "ro_id": "",
      "ro_name": "",
    });
  }

  private ionViewWillEnter() {
    console.log("CommitteeMemberUpdatePage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("CommitteeMemberUpdatePage onInitPage");

    if (this.hasDelCMbrAccess) {
      this.role$ = this.db.dbCol({
        "action": "select", "mapObject": "role",
        "sqlExtended": " where role.ro_group IN ('Admin','Committee')  order by ro_order",
      });
    } else {
      this.role$ = this.db.dbCol({
        "action": "select", "mapObject": "role",
        "sqlExtended": " where role.ro_group='Committee'  order by ro_order",
      });
    }

    this.mb_id = this.navParams.get("committeemember").mb_id;
    this.cm_id = this.navParams.get("committeemember").cm_id;
    this.ro_id = this.navParams.get("committeemember").ro_id;
    this.mb_hashname = this.navParams.get("committeemember").mb_hashname;
    this.mb_firstname = this.navParams.get("committeemember").mb_firstname;
    this.mb_lastname = this.navParams.get("committeemember").mb_lastname;
    this.mb_photo = this.navParams.get("committeemember").mb_photo;
    this.ro_name = this.navParams.get("committeemember").ro_name;
    this.cm_sort = this.navParams.get("committeemember").cm_sort;
    this.committeememberForm.controls.ro_id.setValue(this.ro_id);
    this.committeememberForm.controls.ro_name.setValue(this.ro_name);
  }

  private ngOnDestroy() {
    console.log("CommitteeMemberUpdatePage ngOnDestroy");
    this.role$ = null;
  }

  private goback() {
    console.log("CommitteeMemberUpdatePage goback");
    this.navCtrl.pop();
  }

  private updateCommitteeMember(id: string, value: any) {
    console.log("CommitteeMemberUpdatePage updateCommitteeMember");
    const memberValues: any = {
      "cm_sort": value.cm_sort,
      "ref_mb": value.ref_mb,
      "ro_name": value.ro_name,
    };

    this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM committee_member_role WHERE committee_member_role.cm_id=" + this.cm_id + " and ro_id=" + this.ro_id })
      .subscribe((ret) => {
        this.db.dbCol({ "action": "insert", "mapObject": "committee_member_role", "cm_id": this.cm_id, "ro_id": value.ro_id })
          .subscribe((ret2) => {
            this.navCtrl.pop();
          });
      });
  }

  private deleteCommitteeMember(id: string, ref_mb: string) {
    console.log("CommitteeMemberViewPage deleteMember");
    this.showConfirm("Committee Member", "Delete " + this.mb_hashname + " from the Committee", id, ref_mb);
  }

  private showConfirm(title: string, message: string, id: string, ref_mb: string) {
    console.log("CommitteeMemberViewPage showConfirm");
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({ "action": "select", "mapObject": "committee_member_role", "sqlExtended": " where committee_member.cm_id = " + this.navParams.get("committeemember").cm_id })
              .subscribe((ret) => {
                if (ret.length === 1) {
                  // If the Member has only one role than the role must be del
                  this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM committee_member_role WHERE committee_member_role.cr_id = " + this.navParams.get("committeemember").cr_id })
                    .subscribe((ret1) => {
                      this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM committee_member WHERE committee_member.cm_id=" + this.navParams.get("committeemember").cm_id })
                        .subscribe((ret2) => {
                          this.navCtrl.pop();
                        });
                    });
                }
                else {
                  this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM committee_member_role WHERE committee_member_role.cr_id = " + this.navParams.get("committeemember").cr_id })
                    .subscribe((ret3) => {
                      this.navCtrl.pop();
                    });
                }
              });
          },
          "text": "Yes",
        },
        {
          "handler": () => { },
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/committee/committeemember_update.ts